((win, doc, clarity, scriptType, tagId) => {
  win[clarity] =
    win[clarity] ||
    function () {
      (win[clarity].q = win[clarity].q || []).push(arguments);
    };

  const clarityScript = doc.createElement(scriptType);
  clarityScript.async = true;
  clarityScript.src = `https://www.clarity.ms/tag/${tagId}`;

  const firstScript = doc.getElementsByTagName(scriptType)[0];
  firstScript.parentNode.insertBefore(clarityScript, firstScript);
})(window, document, 'clarity', 'script', 'kupafy17un');
